export enum ConversationStatusEnum {
  Open = 'open',
  Resolved = 'resolved',
}
